import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import OverlayContainer from "@components/Overlay/OverlayContainer";
import { userActions } from "../../../_actions";

const SessionExpire = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [signoutTime, setSignoutTime] = useState(1200000);
  const [warningTime, setWarningTime] = useState(900000);
  const [sessionWarning, setSessionWarning] = useState(false);
  const [manageSession, setManageSession] = useState(false);
  const [seconds, setSeconds] = useState(0);
  const [minutes, setMinutes] = useState(5);

  const content = {
    warningTitle: "Session Expiring Soon",
    warningContent:
      "You have gone a while. For security this page is expiring soon. Please click on OK to continue.",
    expiredTitle: "Session Expired",
    expiredContent: "The page expired due to inactivity. Please login again",
  };

  let warnTimeout;
  let logoutTimeout;

  const warn = () => {
    setSessionWarning(true);
    setManageSession(false);
    setSeconds(0);
    setMinutes(5);
  };
  const logout = () => {
    setSessionWarning(false);
    setManageSession(true);
    localStorage.removeItem("token");
  };

  const setTimeouts = () => {
    warnTimeout = setTimeout(warn, warningTime);
    logoutTimeout = setTimeout(logout, signoutTime);
  };

  function updateTime() {
    if (minutes == 0 && seconds == 0) {
      setSeconds(0);
      setMinutes(5);
    } else {
      if (seconds == 0) {
        setMinutes((minutes) => minutes - 1);
        setSeconds(59);
      } else {
        setSeconds((seconds) => seconds - 1);
      }
    }
  }

  const clearTimeouts = () => {
    if (warnTimeout) clearTimeout(warnTimeout);
    if (logoutTimeout) clearTimeout(logoutTimeout);
  };

  const handleSessionWarning = () => {
    setSessionWarning(false);
    setSeconds(0);
    setMinutes(5);
  };

  const handleSessionExpired = () => {
    setManageSession(false);
    dispatch(userActions.logout());
    navigate("/");
    localStorage.removeItem("token");
  };

  useEffect(() => {
    const events = [
      "load",
      "mousemove",
      "mousedown",
      "click",
      "scroll",
      "keypress",
    ];

    const resetTimeout = () => {
      clearTimeouts();
      setTimeouts();
    };

    for (let i in events) {
      window.addEventListener(events[i], resetTimeout);
    }

    setTimeouts();
    return () => {
      for (let i in events) {
        window.removeEventListener(events[i], resetTimeout);
        clearTimeouts();
      }
    };
  }, []);

  useEffect(() => {
    const token = setTimeout(updateTime, 1000);
    return function cleanUp() {
      clearTimeout(token);
    };
  });

  return (
    <>
      {sessionWarning ? (
        <OverlayContainer>
          <div>
            <div className="alert-dialog-inner">
              <div className="close-wrapper">
                <i className="icon check"></i>
              </div>
              <div>
                <div className="alert-title"></div>
                <h3 className="error">{`${
                  sessionWarning
                    ? `${content.warningTitle}`
                    : `${content.expiredTitle}`
                }`}</h3>
                <p className="text-center">
                  {`${
                    sessionWarning
                      ? `${content.warningContent}`
                      : `${content.expiredContent}`
                  }`}
                </p>
                <p className="text-center">
                  Time left: {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
                </p>
              </div>
              <div className="alert-close-btn">
                <Link
                  to="#"
                  className="btn-save"
                  onClick={handleSessionWarning}
                >
                  OK
                </Link>
              </div>
            </div>
          </div>
        </OverlayContainer>
      ) : (
        manageSession && (
          <OverlayContainer>
            <div>
              <div className="alert-dialog-inner">
                <div className="close-wrapper" onClick={handleSessionExpired}>
                  <i className="icon check"></i>
                </div>
                <div>
                  <div className="alert-title"></div>
                  <h3 className="error">{`${
                    sessionWarning
                      ? `${content.warningTitle}`
                      : `${content.expiredTitle}`
                  }`}</h3>
                  <p className="text-center">
                    {`${
                      sessionWarning
                        ? `${content.warningContent}`
                        : `${content.expiredContent}`
                    }`}
                  </p>
                </div>
                <div className="alert-close-btn">
                  <Link
                    to="#"
                    className="btn-save"
                    onClick={handleSessionExpired}
                  >
                    Close
                  </Link>
                </div>
              </div>
            </div>
          </OverlayContainer>
        )
      )}
    </>
  );
};
export default SessionExpire;
